module.exports = "/_next/static/images/56a82b8aa299dca867ae9f274f3c4827-cardHasArrivedDebit.svg.webp";